/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Chip_ReferencesInputs */

const en_why_listening_chip_references = /** @type {(inputs: Why_Listening_Chip_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference list`)
};

const es_why_listening_chip_references = /** @type {(inputs: Why_Listening_Chip_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de referencias`)
};

/**
* | output |
* | --- |
* | "Reference list" |
*
* @param {Why_Listening_Chip_ReferencesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_chip_references = /** @type {((inputs?: Why_Listening_Chip_ReferencesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Chip_ReferencesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_chip_references(inputs)
	return en_why_listening_chip_references(inputs)
});